<template>
    <div class="headerclass">
         <div v-if="!loggedIn">
           <img alt="school logo" :src="LogoPath"  class="loginlogo" >
         </div>
         
         <div v-if="loggedIn" class="horizFlexStretch">
            <div class="vertFlexTop leftjustified">
              <img alt="school logo" :src="LogoPath"  class="logo" v-if="LogoPath!=''">
              <label class="headertextbold">{{loggedInUser.LocationName}}</label>
           </div>
           <div v-if="needsUpdate">
              <p class="update">Updates are available for your application. Please click Refresh to download the latest version.</p>
              <button @click="refreshapp()">Refresh</button>
          </div>
           <div class="vertFlexTop rightjustified" v-if="requireLogin">
             <label class="headertextbold">{{loggedInUser.name}}</label>
             <linkbutton class="logoutButton" toplabel="Logout" @click="logout()" />
  
               <select name="" id="" class='entrySelect selaccount' v-model="location.id"  @change="selectLocation()" v-if="!locationAndTerminalPreselected">
                  <option v-for="loc in LocationList" :key="loc.id" :value="loc.id" >
                      {{loc.name}}
                  </option>
              </select>
  
              <select name="" id="" class='entrySelect selaccount' v-model="terminalId"  v-if="location.maxTerminalId>0 && !locationAndTerminalPreselected" @change="selectLocation()" >
                  <option v-for="t in terminalList" :key="t.id" :value="t.id" >
                      {{t.name}}
                  </option>
              </select>
  
              <label class="headertext" v-if="locationAndTerminalPreselected">{{location.name}}</label>
              <label class="headertext" v-if="locationAndTerminalPreselected">Terminal {{terminalId}}</label>
  
              
  
              
           </div>
         </div>
         <div v-if="loggedIn" class="horizFlexStretch">
          <div class="suspendbuttons">
            <smallbutton buttonclass=" startbutton" toplabel="New Ticket" @click="startNewTicket()"/>
            <reservations buttonClass="shortbutton" />
          </div>
          
          <div class="topmessage">
            <label class="responsemessage topmessagelabel">{{responseMessage}}</label>
            <div class="margin10">
              <linkbutton  toplabel="Refresh" v-if="businessDayId==-1" @click="selectLocation"/>
            </div>
            
           </div>
  
          </div>  
      </div>
  </template>
  
  <script>
  import datamethods from '../../services/datamethods.js'
   import {mapFields} from 'vuex-map-fields'
    import smallbutton from '../controls/button.vue'
   import linkbutton from  '../controls/linkbutton.vue'
   import confirm from '../actions/confirm.vue'
   import pos from '../../services/pos.js'
    import pos_culinary from '../../services/pos_culinary.js'
    import pay from '../../services/pay.js'
    import reservations from '../actions/reservations.vue'
  export default {
      name:'header_culinarymobile',
      components:{
          linkbutton,
          confirm,
          reservations,
          smallbutton
      },
       mixins:[datamethods,pos,pay,pos_culinary],
      computed:{
          ...mapFields([
              'loggedInUser',
              'loggedIn',
              'requireLogin',
              'location',
              'pleaseWait',
              'responseMessage',
              'needsUpdate',
          ]),
          

      },
      data(){
          return{
              
              falseParam:false,
              trueParam:true
          }
      },
      methods:{
        refreshapp(){
              location.reload(true);
        },
        
      },
      mounted(){
          this.getLocations();
      }
  }
  </script>
  
  <style>
  .headerclass{
    background-color:var(--header-color);
   
  }
  .suspendbuttons{
    padding-bottom:10px;
    display:flex;
    flex-direction:row;
  }
  .vertFlexTop{
    display:flex;
    flex-direction: column;
    margin:5px;
    align-items: top;
  }
  .logo{
        height:70px;
    }
    .loginlogo{
        height:80px;
        margin-right:0px;
        margin-top:10px;
      }
      .shortbutton{
        border: none;
        border-radius:10px;
        width:135px;
        height:40px;
        padding:0px;
        font-size: medium;
        margin:10px;
        text-decoration: none;
        background-color:var( --button-color);
        color:var(--button-text-color);
  
      }
      .startbutton{
        border: none;
        border-radius:10px;
        width:135px;
        height:40px;
        padding:0px;
        font-size: medium;
        margin:10px;
        text-decoration: none;
        background-color:var(--color-payment);
        color:var(--button-text-color);
      }
      .topmessage{
        display:flex;
        flex-direction: row;
        align-items:center
      }
      .topmessagelabel{
        vertical-align: middle;
      }
  </style>